import { lazy } from "react";

export const TanStackRouterDevtools =
  import.meta.env.MODE === "production"
    ? () => null
    : lazy(() =>
        import("@tanstack/react-router-devtools").then(
          (res) => ({
            default: res.TanStackRouterDevtools,
          })
        )
      );

export const ReactQueryDevtools =
  import.meta.env.MODE === "production"
    ? () => null
    : lazy(() =>
        import("@tanstack/react-query-devtools").then(
          (res) => ({
            default: res.ReactQueryDevtools,
          })
        )
      );
